var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIDemorado(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#1D5187"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 32L22.5 24.875C22.3448 24.7586 22.2188 24.6076 22.132 24.434C22.0452 24.2604 22 24.0691 22 23.875V18.25C22 17.9185 22.1317 17.6005 22.3661 17.3661C22.6005 17.1317 22.9185 17 23.25 17H40.75C41.0815 17 41.3995 17.1317 41.6339 17.3661C41.8683 17.6005 42 17.9185 42 18.25V23.8187C41.9994 24.0115 41.9542 24.2015 41.868 24.3739C41.7818 24.5463 41.657 24.6964 41.5031 24.8125L32 32Z",
    stroke: "#B5E9FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 32L22.5 39.125C22.3448 39.2414 22.2188 39.3924 22.132 39.566C22.0452 39.7396 22 39.9309 22 40.125V45.75C22 46.0815 22.1317 46.3995 22.3661 46.6339C22.6005 46.8683 22.9185 47 23.25 47H40.75C41.0815 47 41.3995 46.8683 41.6339 46.6339C41.8683 46.3995 42 46.0815 42 45.75V40.1813C41.9999 39.988 41.9549 39.7974 41.8687 39.6244C41.7825 39.4514 41.6574 39.3008 41.5031 39.1844L32 32Z",
    stroke: "#B5E9FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 38.25V32",
    stroke: "#B5E9FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6672 25.75H40.2688",
    stroke: "#B5E9FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIDemorado);
export default __webpack_public_path__ + "static/media/i-demorado.43f049d2959b3156dd73b604525cf90e.svg";
export { ForwardRef as ReactComponent };